import { React, useState } from "react";
// import "./dashboard.scss";
import Modal from "react-bootstrap/Modal";
import axios from 'axios';
function Dashboard() {
  const [smShow, setSmShow] = useState(false);
  const [query, setQuery] = useState('');
  const [response, setResponse] = useState('');
  const apiUrl = "https://nexgenbackend.octalooptechnologies.com/add_query_response";
  // const [lgShow, setLgShow] = useState(false);
  function Handle() {
    if (query.length > 0 && response.length > 0) {
      const requestData = {
        user_query: query,
        gpt_response: response,
      };
      axios
        .post(apiUrl, requestData)
        .then(response => {
          const data = response.data.status;
          console.log('API Response:', data);
          setSmShow(true);


          // Handle the response data as needed
        })
        .catch(error => {
          console.error('Error:', error);
          // Handle errors
        });
    } else {
      alert("Please Enter All Field");
    }
  }
  return (
    <div className="dashboard">
      <div className="main">
        <div className="title">
          <input
            className="query"
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="User Query"
          />
        </div>
        <hr />

        <div className="content">
          <textarea
            className="response"
            type="text"
            value={response}
            onChange={(e) => setResponse(e.target.value)}
            placeholder="Response of Query"
          />
        </div>
      </div>
      <div className="add_databases_btn">
        <button onClick={() => Handle()}>Add to Database</button>
      </div>

      <Modal
        size="sm"
        centered
        show={smShow}
        onHide={() => setSmShow(false)}
        aria-labelledby="example-modal-sizes-title-sm"
        className="success_modal"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-sm">
            <img src="/success.png" alt="" />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>Success</Modal.Body>
      </Modal>
    </div>
  );
}

export default Dashboard;
